<template>
  <WsRead
    :modelName="modelName"
    :submodelName="submodelName"
    :modelVersionName="_modelVersionName"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :modeVersions="modeVersions"
    :createVersion="true"
    :submodelVerisonName="submodelVerisonName"
    :submodelVerisonFullName="submodelVerisonFullName"
    titleKey="last_version.name"
    :customBtns="_customBtns"
    :versionCreatable="false"
    :sortable="true"
    :isFetchData="isFetchData"
    :hasSequence="hasSequence"
    :itemVersionLinkCreatable="itemVersionLinkCreatable"
    :itemVersionCreatable="_itemVersionCreatable"
    :itemVersionReadable="_itemVersionReadable"
    :itemEditable="_itemEditable"
    :itemDeletable="itemDeletable"
    :sequenceFields="_sequenceFields"
    :isPostVersion="_isPostVersion"
    @input="$_getModelData($event)"
    @versionPostable="$_onPostVersionAlert()"
    @createTemplateVersion="$_onCreateVersionAlert()"
    @unbind-item-from-parent="$_onUnbindItemFromParent($event)"
  >
    <WsAlertDialog
      ref="postVersionAlertDialog"
      :title="alertTitle"
      :description="alertDescription"
      :btnText="btnText"
      @submit="$_onPostVersion()"
    />
    <WsAlertDialog
      ref="createVersionAlertDialog"
      :title="alertTitle"
      :description="alertDescription"
      :btnText="btnText"
      @submit="$_onCreateVersion()"
    />
  </WsRead>
</template>

<script>
import model from "@/models/checklist_template";
import submodel from "@/models/checklist_question_template";
import S_base from '@/services/wasaapi/__base';
import H_checklistQuestionTemplate from '@/helpers/checklistQuestionTemplate';

export default {
  data() {
    return {
      modelName: model.modelName,
      submodelName: submodel.modelName,
      submodelVerisonName: "v2/cklist_ques_tmp_ver",
      submodelVerisonFullName: "checklist_question_template_version",
      hasSequence: true,
      label: model.label,
      localeMode: true,
      modeVersions: true,
      fields: model.fields,
      modelVersionData: {},
      alertTitle: "",
      alertDescription: "",
      btnText: "",
      isFetchData: false,
      modelData: null,
      itemVersionLinkCreatable: false,
      itemDeletable: false,
      pageSetting: {
        primary: [
          {
            type: "infoCard",
            hideOnNull: false,
            floors: [
              {
                fields: ["last_version.locales"],
                hideLabelFields: [],
              },
            ],
          },
          {
            type: "expandList",
            label: submodel.label,
            modelName: submodel.modelName,
            modelVersionName: "v2/cklist_ques_tmp_ver",
            modelNameInParams: false,
            modelTemplateNameInParams: true,
            modeParent: true,
            modeParentVersions: true,
            modeVersions: true,
            fields: submodel.fields,
            orderBy: "created_at",
            titleKey: "last_version.title",
            fieldsRead: submodel.fieldsRead,
            searchMode: false,
            hideOnNull: true,
            isGetAll: true,
            customParentData: (parentData) => {
              const areas = parentData.areas.map((area)=>area.id)
              return {
                version_status: parentData.last_version.version_status,
                areas,
              };
            },
            staticModelData: this.$_expandListStaticModelData,
            customCreateAction: this.$_expandListCustomSubmitAction,
            customUpdateAction: this.$_expandListCustomSubmitAction,
            itemVersionReadableUrl(data) {
              return `/cklist_ques_tmp_ver/${data.id}/version`;
            },
          },
        ],
        secondary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "設定",
                fields: [
                  "frequency",
                  "areas",
                  "industry_categories",
                  "system_classes",
                  "system_subclasses",
                  "range_type",
                  "factories",
                  "exclusive_factories",
                ],
              },
            ],
          },
          {
            type: "infoCard",
            floors: [
              {
                title: "建立資訊",
                fields: ["created_admin", "created_at"],
              },
            ],
          },
          {
            type: "infoCard",
            floors: [
              {
                title: "編輯資訊",
                fields: ["last_version.updated_admin", "last_version.updated_at"],
              },
            ],
          },
          {
            type: "select",
            title: "啟用",
            remark: "隱藏的內容將不會顯示於前端",
            field: "status",
          },
        ],
      }
    };
  },
  computed: {
    _modelVersionName() {
      return `${this.modelName}_version`;
    },
    _customBtns() {
      return [
        {
          title: `複製`,
          color: "textSecondary",
          outlined: true,
          icon: "mdi-content-copy",
          to: `/checklist_template/${this.$route.params.id}/duplicate`,
          checkDisplayOnModelData: function(){return true},
        },
        {
          title: `更新版本`,
          color: "textSecondary",
          outlined: true,
          icon: "mdi-update",
          emit: "createTemplateVersion",
          checkDisplayOnModelData: (modelData) => {
            if (modelData.last_version.version_status) {
              return true;
            } else {
              return false;
            }
          },
        },
        {
          title: "發布新版本",
          color: "textSecondary",
          outlined: true,
          icon: "mdi-update",
          emit: "versionPostable",
          checkDisplayOnModelData: (modelData) => {
            if (modelData.last_version.version_status) {
              return false;
            } else {
              return true;
            }
          },
        },
        {
          tooltip: `刪除`,
          checkDisplayOnModelData: function(){return false},
          isDisplay: true,
          icon: "mdi-delete",
          emit: "unbind-item-from-parent",
          customFunction: function(modelDatas, event) {
            if (!modelDatas || !event.itemId) return
            const tarIndex = modelDatas.findIndex((e) => { return e.last_version.id === event.itemId}); 
            modelDatas.splice(tarIndex, 1);
          }
        },
      ];
    },
    _sequenceFields() {
      if (this.modelData) {
        return this.modelData.last_version.questions;
      } else {
        return null;
      }
    },
    _isPostVersion() {
      if (this.modelData) {
        if (this.modelData.last_version) {
          if (!this.modelData.last_version.version_status) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    _itemVersionCreatable() {
      if (this.modelData) {
        if (this.modelData.last_version) {
          if (!this.modelData.last_version.version_status) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    _itemVersionReadable() {
      if (this.modelData) {
        if (this.modelData.last_version) {
          if (!this.modelData.last_version.version_status) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    _itemEditable() {
      if (this.modelData) {
        if (this.modelData.last_version) {
          if (!this.modelData.last_version.version_status) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  methods: {
    $_onAlert() {
      this.$refs.alertDialog.close();
    },
    async $_getModelVersionData(modelData) {
      try {
        let getUrl = `/${this._modelVersionName}/${modelData.last_version.id}`;
        const res = await this.$axios.get(getUrl);
        this.modelVersionData = res.data.data;
      } catch (error) {
        alert(error);
      }
    },
    $_onPostVersionAlert() {
      this.alertTitle = "發布新版本";
      this.alertDescription = "確定要發布新版本嗎？";
      this.btnText = "確認";
      this.$refs.postVersionAlertDialog.open();
    },
    async $_setAllQuesTempVersionRelease() {
      const newArr = [];
      this.modelVersionData[`${this.submodelVerisonFullName}s`].forEach(queVersion => {
          if (queVersion.status == 0) {
            newArr.push(
              this.$axios.patch(`/${this.submodelVerisonName}/${queVersion.id}`, {status: 1})
            );
          }
        }
      );
      if (newArr.length) await Promise.all(newArr);
    },
    async $_setChecklistTempVersionRelease() {
      await this.$axios.patch(
        `/${this._modelVersionName}/${this.modelVersionData.id}`,
        { version_status: 1 }
      );
    },
    async $_setChecklistTempRelease() {
      await S_base.update({
        modelName: this.modelName,
        modelId: this.$route.params.id,
        payload: {status: 1},
      });
    },
    async $_onPostVersion() {
      try {
        this.$refs.postVersionAlertDialog.startLoading();
        await this.$_getModelVersionData(this.modelData);
        await this.$_setAllQuesTempVersionRelease();
        await this.$_setChecklistTempVersionRelease();
        await this.$_setChecklistTempRelease();
        this.$refs.postVersionAlertDialog.close();
        this.$refs.postVersionAlertDialog.stopLoading();
        this.isFetchData = !this.isFetchData;
      } catch (error) {
        alert(error);
      }
    },
    $_onCreateVersionAlert() {
      this.alertTitle = "更新版本";
      this.alertDescription = "確定要建立一個新的公版版本嗎？";
      this.btnText = "確認";
      this.$refs.createVersionAlertDialog.open();
    },
    async $_setAllQuesTempVersionUnRelease() {
      const newArr = [];
      this.modelVersionData[`${this.submodelVerisonFullName}s`].forEach(queVersion => {
        if (queVersion.status == 1) {
          newArr.push(this.$axios.patch(`/${this.submodelVerisonName}/${queVersion.id}`, {status: 0}));
        }
      });
      if (newArr.length) await Promise.all(newArr);
    },
    async $_createChecklistTempVersion() {
      let checklistTempVersion = JSON.parse(JSON.stringify(this.modelVersionData));
      const quesIdList = checklistTempVersion[`${this.submodelName}s`].map(item => item.id);
      const quesVersionIdList = [];
      const quesTempList = await this.$axios.get(`/${this.submodelName}/`, {params: {
        [`${this.modelName}s`]: this.$route.params.id
      }});
      quesTempList.data.data.forEach(quesTemp => {
        checklistTempVersion.questions.forEach((modelVersionItem) => {
          if (modelVersionItem.id === quesTemp.id) {
            quesVersionIdList.push(
              quesTemp.last_version.id
            );
          }
        });
      });
      checklistTempVersion = {
        ...checklistTempVersion,
        version_status: 0,
        [`${this.submodelName}s`]: quesIdList,
        [`${this.submodelVerisonFullName}s`]: quesVersionIdList,
      }
      await this.$axios.post(
        `/${this.modelName}/${this.$route.params.id}/${this._modelVersionName}`,
        checklistTempVersion
      );
    },
    async $_setChecklistTempUnRelease() {
      await S_base.update({
        modelName: this.modelName,
        modelId: this.$route.params.id,
        payload: {status: 2},
      })
    },
    async $_onCreateVersion() {
      try {
        this.$refs.createVersionAlertDialog.startLoading();
        await this.$_getModelVersionData(this.modelData);
        await this.$_setAllQuesTempVersionUnRelease();
        await this.$_createChecklistTempVersion();
        await this.$_setChecklistTempUnRelease();
        this.$refs.createVersionAlertDialog.close();
        this.$refs.createVersionAlertDialog.stopLoading();
        this.isFetchData = !this.isFetchData;
      } catch (error) {
        alert(error);
      }
    },
    $_getModelData($event) {
      this.modelData = $event;
    },
    async $_onUnbindItemFromParent($event){
      try {
        const checklist_template_versions = { checklist_template_versions: [$event.parentId]}
        await this.$axios.post(`/cklist_ques_tmp_ver/${$event.itemId}/remove`, checklist_template_versions);
      } catch(error) {
        alert(error)
      }
    },
    $_expandListStaticModelData(rawData) {
      return H_checklistQuestionTemplate.setShowData(rawData);
    },
    $_expandListCustomSubmitAction(rawData){
      return H_checklistQuestionTemplate.setSubmitData(rawData);
    }
  },
};
</script>